import { Link } from 'gatsby';
import * as React from 'react';
import styles from './Footer.module.scss';
import Text from '../atoms/Text';
import Image from '../atoms/Image';

const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.menubar}>
      <Link to="https:///www.hrbrain.co.jp" className={styles.logo}>
        <Image
          alt="HRBrain"
          path="Company-logo_white.svg"
          className={styles.logo__white}
        />
      </Link>
    </div>
    <Text color="white" className={styles.note}>
      Copyright &copy; HRBrain, Inc. All Rights Reserved.
    </Text>
  </div>
);

export default Footer;
